"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.getItems = getItems;
exports.addItem = addItem;
exports.removeItem = removeItem;
exports.removeItems = removeItems;
exports.updateItemQuantity = updateItemQuantity;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getKey(type) {
  var type_name = {
    reception: "reception",
    pickup: "pickup"
  }[type.toString()];

  switch (type_name) {
    case "reception":
    case "pickup":
      break;
    default:
      throw Error.new("Cart type not found");
  }

  return "maaporssi/" + type + "_vouchers/cart";
}

function getItems(type) {
  var key = getKey(type);
  var result = sessionStorage.getItem(key) || (0, _stringify2.default)([]);
  return JSON.parse(result);
}

function saveItems(items, type) {
  var key = getKey(type);
  sessionStorage.setItem(key, (0, _stringify2.default)(items));
}

function addItem(item, type) {
  var items = getItems(type);
  var hasItem = false;

  items.forEach(function (it) {
    if (it.id === item.id) {
      it.quantity += item.quantity;
      hasItem = true;
    }
  });

  if (!hasItem) {
    items.push(item);
  }
  saveItems(items, type);
}

function removeItem(item, type) {
  var items = getItems(type).filter(function (it) {
    return it.id !== item.id;
  });
  saveItems(items, type);
}

function removeItems(type) {
  saveItems([], type);
}

function updateItemQuantity(item, quantity, type) {
  var items = getItems(type);
  items.forEach(function (it) {
    if (it.id === item.id) {
      it.quantity = quantity;
    }
  });
  saveItems(items, type);
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/ShoppingCartUtil.js
 ** module id = 314
 ** module chunks = 0
 **/